// @flow
import * as React from 'react';
import { Table, Tag, Button, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { getTeamUrl } from 'Common';

type Props = {
  suppliers: [],
  pagination: {},
  fetching: boolean,

  onChangeTable: () => void
}

export default class extends React.PureComponent<Props> {

  render() {
    const {
      suppliers,
      pagination,
      fetching,

      onChangeTable
    } = this.props;

    const columns = [

      {
        title: 'Company Name',
        dataIndex: 'company_name',
        key: 'company_name',
        sorter: true,
        render: (text, record) => (
          <React.Fragment>
            <NavLink to={getTeamUrl(`suppliers/${record.id}/view`)}>
              {record.company_name}
            </NavLink>
            {record.trading_name && (
              <div style={{ fontSize: 13, color: '#9e9e9e' }}>
                Trading as: {record.trading_name}
              </div>
            )}
          </React.Fragment>
        )
      },

      {
        title: 'Contact',
        dataIndex: 'email',
        render: (text, record) => (
          <React.Fragment>
            {record.email && <div>{record.email}</div>}
            {record.phone && <div style={{ fontSize: 13, color: '#9e9e9e' }}>{record.phone}</div>}
          </React.Fragment>
        )
      },

      {
        title: 'Location',
        dataIndex: 'city',
        render: (text, record) => (
          <React.Fragment>
            {record.city && <div>{record.city}</div>}
            {record.postcode && <div style={{ fontSize: 13, color: '#9e9e9e' }}>{record.postcode}</div>}
          </React.Fragment>
        )
      },

      {
        title: 'Payment Terms',
        dataIndex: 'payment_terms',
        width: 150,
      },

      {
        title: 'Active Items',
        dataIndex: 'active_items_count',
        key: 'active_items_count',
        width: 120,
        align: 'center',
        render: (text, record) => record.active_items_count || 0
      },

      {
        title: 'Status',
        dataIndex: 'active',
        key: 'active',
        width: 110,
        align: 'center',
        render: (text, record) => record.active ? (
          <Tag icon={<CheckCircleOutlined />} color="success">Active</Tag>
        ) : (
          <Tag icon={<CloseCircleOutlined />} color="default">Inactive</Tag>
        )
      },

      /* Actions column - commented out, row click handles navigation
      {
        title: 'Actions',
        key: 'actions',
        width: 120,
        align: 'center',
        render: (text, record) => (
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
            <Button
              type="link"
              icon={<EditOutlined />}
              size="small"
              onClick={() => window.location.href = getTeamUrl(`suppliers/${record.id}/view`)}
            />
            <Popconfirm
              title="Are you sure you want to delete this supplier?"
              onConfirm={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="link"
                danger
                icon={<DeleteOutlined />}
                size="small"
              />
            </Popconfirm>
          </div>
        )
      },
      */

    ];

    const scroll = { x: 1200 }

    return (
      <Table
        dataSource={suppliers}
        columns={columns}
        rowKey={record => record.id}
        loading={fetching}
        onChange={onChangeTable}
        scroll={scroll}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          ...pagination
        }}
        bordered
        onRow={record => ({
          onClick: () => { window.location.href = getTeamUrl(`suppliers/${record.id}/view`); },
          style: { cursor: 'pointer' },
        })}
      />
    )

  };

}
